import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADAIACA entity - alias of ADObject
 * Represents Active Directory AIA CA objects
 */
export const adAIACAEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADAIACA', display: 'AD AIA CA' },
  alias: 'ADObject',
};
